const customNewDate = () => {
  const currentDate = new Date()
  currentDate.setMinutes(0)
  currentDate.setSeconds(0)
  currentDate.setMilliseconds(0)

  return currentDate
}

const Now = () => {
  return customNewDate()
}

export const getFilterDateRanges = () => {
  const currentYear = Now().getFullYear()
  return [
    {
      label: 'Last 30 days',
      from: new Date(Now().setDate(Now().getDate() - 30)),
      to: customNewDate(),
    },
    {
      label: 'Last 90 days',
      from: new Date(Now().setDate(Now().getDate() - 90)),
      to: customNewDate(),
    },
    {
      label: `This year (${currentYear})`,

      from: new Date(Now().getFullYear(), 0, 1),
      to: customNewDate(),
    },
    {
      label: `Last year (${currentYear - 1})`,
      from: new Date(Now().getFullYear() - 1, 0, 1),
      to: new Date(Now().getFullYear() - 1, 11, 31),
    },
  ]
}
